import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';

const TrialDetailsList = ({ rows }) => (
  <ul className="flex flex-wrap list pa0">
    {rows.map((row) => (
      <li key={`detail-row=${shortid.generate()}`} className="basis-100 pa1 flex striped--near-white mb1">
        {row.map((column) => (
          <span key={`detail-row=${shortid.generate()}`} className="basis-50">{column}</span>
        ))}
      </li>
    ))}
  </ul>
);

TrialDetailsList.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
};

export default TrialDetailsList;
